// extracted by mini-css-extract-plugin
export default {"breadcrumb":"DirectoryLocation_breadcrumb__iSQnZ font-sm-regular"};